import React, { useEffect, useState } from "react";
import ReactJson from "react-json-view";
import { Switch } from "@headlessui/react";
import { Button } from "player-components";
import { useDispatch, useSelector } from "react-redux";
import platform from "platform";
import ComponentPackageJson from "player-components/package.json";




import { addNotificationAsync, selectClientConfig, selectParentVersion, selectShowDeveloperTools, setFeedbackModalVisible, setShowDeveloperTools, setLibraryEndpoint } from "../../features/ui/uiSlice";
// import { addNotificationAsync, selectClientConfig, selectParentVersion, selectShowDeveloeprTools, selectShowDeveloperTools, setFeedbackModalVisible, setShowDeveloperTools } from "../../features/ui/uiSlice";

import { clearAudioStorage } from "../../services/assetStore";
import { persistor } from "../../store";
import { store } from "../../store";

import PackageJSON from "../../../package.json";
import ComponentsPackageJson from "player-components/package.json";
import { selectError, unmountSessionAsync } from "../../features/session/sessionSlice";
import { triggerBlobDownload } from "../../factories/ui";
import { selectUser, logout } from "../../features/auth/authSlice";


import { flipStorageBackend } from '../../flipStorageBackend';
import { replaceAllSetlists } from "../../features/setlists/setlistsSlice";
import { replaceAllLibrarySongs } from "../../features/library/librarySlice";
import { clearUgcLocalData } from "../../utils/ugcTesting";


// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';
import { refreshChoirPlayerApp } from '../../utils/refreshApp';


// pgw 02-oct-2025
// connectivity probe you can call ad-hoc
async function isReallyOnline(timeoutMs = 2000) {
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    clearTimeout(t);
  }
}


const Settings = () => {
  const dispatch = useDispatch();

  const showDeveloperTools = useSelector(selectShowDeveloperTools);
  const clientConfiguration = useSelector(selectClientConfig);
  const parentVersion = useSelector(selectParentVersion);
  const currentUser = useSelector(selectUser);

  const [storageConsumption, setStorageConsumption] = useState(0);
  const sessionError = useSelector(selectError);

  // pgw 01-aug-2025
  let songListNum = 1;



  // pgw 27-mar-2026 - play all songs in songlist
  const [debugAutoplay10s, setDebugAutoplay10s] = useState(() => {
	try {
	  return localStorage.getItem("debugAutoplay10s") === "1";
	} catch (e) {
	  return false;
	}
  });

  useEffect(() => {
	try {
	  window.__DEBUG_AUTOPLAY_10S__ = debugAutoplay10s;
	  localStorage.setItem("debugAutoplay10s", debugAutoplay10s ? "1" : "0");
	  // console.log("[DEBUG AUTOPLAY 10S] set to", debugAutoplay10s);
	} catch (e) {
	  console.warn("[DEBUG AUTOPLAY 10S] failed to persist", e);
	}
  }, [debugAutoplay10s]);



const runSpecialOptionsLogoutAndRefresh = async () => {
  console.log("[specialOptions] logout + refresh start");

  dispatch(replaceAllSetlists([]));
  dispatch(replaceAllLibrarySongs([]));
  clearUgcLocalData();
  window.localStorage.removeItem("AUTH_TOKEN");

  dispatch(unmountSessionAsync());

  try {
    if (typeof caches !== "undefined" && caches?.keys) {
      const cacheNames = await caches.keys();

      for (const cacheName of cacheNames) {
        console.log("[specialOptions] deleting cache =", cacheName);
        await caches.delete(cacheName);
      }
    }

    if (navigator?.serviceWorker?.getRegistrations) {
      const registrations = await navigator.serviceWorker.getRegistrations();

      for (const registration of registrations) {
        console.log("[specialOptions] unregistering service worker =", registration.scope);
        await registration.unregister();
      }
    }
  } catch (e) {
    console.log("[specialOptions] refresh cleanup error =", e);
  }

  if (
    clientConfiguration?.features?.auth?.mode === "domainCookie" &&
    clientConfiguration?.features?.auth?.domainCookie?.logoutUrl &&
    !currentUser?.guest
  ) {
    const logoutUrl =
      clientConfiguration.features.auth.domainCookie.logoutUrl +
      "?c=" +
      new Date().valueOf();

    console.log("[specialOptions] redirecting to real WordPress logout URL =", logoutUrl);

    window.location.href = logoutUrl;
    return;
  }

  dispatch(logout({
    user: {
      ID: "guest",
      displayName: "Guest User",
      subscribed: false,
      guest: true,
    },
  }));

  console.log("[specialOptions] no WordPress logout needed; reload app");
  window.location.reload();
};



// pgw 10-may-2026 - added special options

async function specialOptionsWithValue() {

  var value = prompt(
    "Enter special option value",
    "0"
  );

  if (value === null) {
    debugLog("[specialOptions] user cancelled prompt → abort");
    return;
  }

  value = String(value).trim();

  console.log("[specialOptions] raw input =", value);

  if (value === "0") {
    console.log("[specialOptions] normal mode");

    window.localStorage.removeItem("ugcTesting");
    window.localStorage.removeItem("cgTesting");
    window.localStorage.removeItem("AUTH_TOKEN");

    await runSpecialOptionsLogoutAndRefresh();
    return;
  }

  if (value === "1") {
    console.log("[specialOptions] ChoirGenius test mode");

    window.localStorage.removeItem("ugcTesting");
    window.localStorage.setItem("cgTesting", "1");

    await runSpecialOptionsLogoutAndRefresh();
    return;
  }


  if (value === "2") {
    console.log("[specialOptions] UGC test mode");

    window.localStorage.removeItem("cgTesting");
    window.localStorage.removeItem("AUTH_TOKEN");
    window.localStorage.setItem("ugcTesting", "1");

    await runSpecialOptionsLogoutAndRefresh();
    return;
  }

  if (value === "3") {
    console.log("[specialOptions] enable save setlists to S3");

    window.localStorage.setItem("saveSetlists", "1");
    return;
  }

  if (value === "4") {
    console.log("[specialOptions] disable save setlists to S3");

    window.localStorage.removeItem("saveSetlists");
    return;
  }

  console.log("[specialOptions] unsupported value =", value);

}



  // pgw 10-apr-2026 - added special options
  // 
  const specialOptions = async () => {

	console.log("pgw 10-apr-2026 specialOptions p1")
	let res
	console.log("pgw 10-apr-2026 specialOptions p2, res = ", res)

	try {

		res = await specialOptionsWithValue();
		console.log("pgw 10-apr-2026 specialOptions p3, res = ", res)
		

	}
	catch(e) {
		console.log("pgw specialOptions e = ", e)
	}

	console.log("pgw 10-apr-2026 specialOptions p4, res = ", res)

  };









// Call this to run the flow:
// clearSiteDataWithMask();   // will prompt for a 7-bit mask like "1010101"

async function clearSiteDataWithMask() {
  debugLog("[mask] ==== CLEAR SITE DATA (bitmask) ====");

  // 1) Ask user for mask
  var mask = prompt(
    "Enter 7-bit mask (left→right):\n" +
    "bit0 clearStorage, bit1 clearCookies, bit2 clearIndexedDB,\n" +
    "bit3 clearCaches, bit4 unregisterSW, bit5 hardReload, bit6 softReload\n" +
    "Example: 0001101",
	"0001101"
  );

  if (mask === null) {
    debugLog("[mask] user cancelled prompt → abort");
    return;
  }


  debugLog("[mask] raw input =", mask);

  // 2) Normalize & validate (only 0/1)
  mask = String(mask);
  mask = mask.replace(/\s+/g, ""); // remove spaces
  var valid = /^[01]+$/.test(mask);
  if (!valid) {
    debugLog("[mask] invalid mask (only 0/1 allowed) → abort");
    return;
  }

  // 3) Ensure length is 7 by left-padding with 0s
  if (mask.length < 7) {
    var need = 7 - mask.length;
    var pad = "";
    var i;
    for (i = 0; i < need; i++) {
      pad += "0";
    }
    mask = pad + mask;
  } else {
    // if longer than 7, keep only the leftmost 7 bits (you can change this rule if you like)
    if (mask.length > 7) {
      debugLog("[mask] mask longer than 7; trimming leftmost 7");
      mask = mask.slice(0, 7);
    }
  }

  debugLog("[mask] normalized 7-bit mask =", mask);

  // 4) Map bits (left→right)
  var b0 = mask.charAt(0); // clearStorage
  var b1 = mask.charAt(1); // clearCookies
  var b2 = mask.charAt(2); // clearIndexedDB
  var b3 = mask.charAt(3); // clearCaches
  var b4 = mask.charAt(4); // unregisterSW
  var b5 = mask.charAt(5); // hardReload
  var b6 = mask.charAt(6); // softReload

  // 5) Convert to booleans (no ternaries)
  var clearStorage = false;
  if (b0 === "1") {
    clearStorage = true;
  }

  var clearCookies = false;
  if (b1 === "1") {
    clearCookies = true;
  }

  var clearIndexedDB = false;
  if (b2 === "1") {
    clearIndexedDB = true;
  }

  var clearCaches = false;
  if (b3 === "1") {
    clearCaches = true;
  }

  var unregisterSW = false;
  if (b4 === "1") {
    unregisterSW = true;
  }

  var hardReload = false;
  if (b5 === "1") {
    hardReload = true;
  }

  var softReload = false;
  if (b6 === "1") {
    softReload = true;
  }

  debugLog("[mask] decisions:", {
    clearStorage: clearStorage,
    clearCookies: clearCookies,
    clearIndexedDB: clearIndexedDB,
    clearCaches: clearCaches,
    unregisterSW: unregisterSW,
    hardReload: hardReload,
    softReload: softReload
  });

  // 6) Execute sections in order, with detailed logging

  // (A) STORAGE
  if (clearStorage) {
    debugLog("[clear] A: clearing localStorage + sessionStorage");
    try {
      localStorage.clear();
      debugLog("[clear] A: localStorage cleared");
    } catch (eA1) {
      debugLog("[clear] A: localStorage.clear error =", eA1);
    }
    try {
      sessionStorage.clear();
      debugLog("[clear] A: sessionStorage cleared");
    } catch (eA2) {
      debugLog("[clear] A: sessionStorage.clear error =", eA2);
    }
  } else {
    debugLog("[clear] A: clearStorage = false → skip");
  }

  // (B) COOKIES
  if (clearCookies) {
    debugLog("[clear] B: clearing cookies");
    try {
      var cookieStr = document.cookie || "";
      var parts = cookieStr.split(";");
      var i2;
      for (i2 = 0; i2 < parts.length; i2++) {
        var cookie = parts[i2] || "";
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        var trimmed = name.trim();
        // standard delete (path=/)
        document.cookie = trimmed + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        // a second attempt without path (covers some cases)
        document.cookie = trimmed + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;";
      }
      debugLog("[clear] B: cookies cleared (visible ones in this path)");
    } catch (eB) {
      debugLog("[clear] B: cookie clear error =", eB);
    }
  } else {
    debugLog("[clear] B: clearCookies = false → skip");
  }

  // (C) INDEXEDDB
  if (clearIndexedDB) {
    debugLog("[clear] C: deleting ALL IndexedDB databases (if supported)");
    try {
      if (typeof indexedDB !== "undefined" && indexedDB && typeof indexedDB.databases === "function") {
        var dbs = await indexedDB.databases();
        if (dbs && dbs.length > 0) {
          var j;
          for (j = 0; j < dbs.length; j++) {
            var db = dbs[j];
            if (db && db.name) {
              debugLog("[clear] C: deleteDatabase:", db.name);
              try {
                indexedDB.deleteDatabase(db.name);
              } catch (eCdel) {
                debugLog("[clear] C: deleteDatabase error for", db.name, "=", eCdel);
              }
            }
          }
        } else {
          debugLog("[clear] C: no databases reported");
        }
      } else {
        debugLog("[clear] C: indexedDB.databases() not supported here → skip");
      }
    } catch (eC) {
      debugLog("[clear] C: IndexedDB error =", eC);
    }
  } else {
    debugLog("[clear] C: clearIndexedDB = false → skip");
  }

  // (D) CACHE API
  if (clearCaches) {
    debugLog("[clear] D: deleting Cache API entries");
    try {
      if (typeof caches !== "undefined" && caches && typeof caches.keys === "function") {
        var cacheNames = await caches.keys();
        if (cacheNames && cacheNames.length > 0) {
          var k;
          for (k = 0; k < cacheNames.length; k++) {
            var name = cacheNames[k];
            debugLog("[clear] D: delete cache:", name);
            try {
              await caches.delete(name);
            } catch (eDdel) {
              debugLog("[clear] D: caches.delete error for", name, "=", eDdel);
            }
          }
        } else {
          debugLog("[clear] D: no caches to delete");
        }
      } else {
        debugLog("[clear] D: Cache API not available → skip");
      }
    } catch (eD) {
      debugLog("[clear] D: Cache API error =", eD);
    }
  } else {
    debugLog("[clear] D: clearCaches = false → skip");
  }

  // (E) SERVICE WORKERS
  if (unregisterSW) {
    debugLog("[clear] E: unregistering all Service Workers");
    try {
      if (typeof navigator !== "undefined" && navigator && navigator.serviceWorker && typeof navigator.serviceWorker.getRegistrations === "function") {
        var registrations = await navigator.serviceWorker.getRegistrations();
        if (registrations && registrations.length > 0) {
          var r;
          for (r = 0; r < registrations.length; r++) {
            var reg = registrations[r];
            try {
              var ok = await reg.unregister();
              debugLog("[clear] E: unregister", ok ? "OK" : "failed", "scope:", reg && reg.scope);
            } catch (eEun) {
              debugLog("[clear] E: unregister error =", eEun);
            }
          }
        } else {
          debugLog("[clear] E: no registrations found");
        }
      } else {
        debugLog("[clear] E: serviceWorker API not available → skip");
      }
    } catch (eE) {
      debugLog("[clear] E: SW error =", eE);
    }
  } else {
    debugLog("[clear] E: unregisterSW = false → skip");
  }

  // 7) Reloads (run in this order if both set)
  if (hardReload) {
    debugLog("[reload] hardReload = true → window.location.reload(true) (deprecated)");
    try {
      window.location.reload(true);
    } catch (eR1) {
      debugLog("[reload] hardReload error =", eR1);
    }
  } else {
    debugLog("[reload] hardReload = false → skip");
  }

  if (softReload) {
    debugLog("[reload] softReload = true → window.location.reload()");
    try {
      window.location.reload();
    } catch (eR2) {
      debugLog("[reload] softReload error =", eR2);
    }
  } else {
    debugLog("[reload] softReload = false → skip");
  }

  debugLog("[mask] ==== DONE ====");
}


	// pgw 22-sep-2025 new version
	// pgw 26-sep-2025 - if offline, warn user that the function will stop app working and give them option to abort
  const deepAppRefresh = async () => {

	// pgw 02-oct-2025
	const ok = await isReallyOnline(2500);
	if (ok) {
		debugLog('user is online')
	}
	else {
		debugLog('user is offline !!')

		let res = confirm("You are offline.\nDoing this will cause the app to stop working !\n Are you sure you want to continue ?\n(OK to continue; Cancel to do nothing) ?")
		debugLog('res = ', res);
		if (res) {
			debugLog("You pressed OK!");
		} else {
			debugLog("You pressed Cancel - returning...");
			return;
		}
	}

	debugLog("pgw 22-sep-2025 deepAppRefresh p1")
	let res
	debugLog("pgw 22-sep-2025 deepAppRefresh p2, res = ", res)

	try {

		res = await clearSiteDataWithMask();
		debugLog("pgw 22-sep-2025 deepAppRefresh p3, res = ", res)

		

	}
	catch(e) {
		debugLog("pgw deepAppRefresh e = ", e)
	}

	debugLog("pgw 22-sep-2025 deepAppRefresh p4, res = ", res)


  };


  const handleToggleDeveloperTools = () => {
    dispatch(setShowDeveloperTools(!showDeveloperTools));
  };

	// pgw 26-sep-2025 - if offline, warn user that the function will stop app working and give them option to abort
  const refreshApp = async () => {
    await refreshChoirPlayerApp({
      source: "settings-refresh-app-button",
      confirmIfOffline: true,
    });
  };


  const handleDownloadState = () => {
    var json = JSON.stringify(store.getState());
    var blob = new Blob([json], { type: "application/json" });
    triggerBlobDownload(blob, `${clientConfiguration.labels.appTitle}-debug-${Date.now()}.debug`);
  };

  const clearCookies = async () => {
	debugLog("pgw clearCookies p1")

	try {
		debugLog("pgw clearCookies p2, document.cookie = ", document.cookie);

		// Get all accessible cookies
		document.cookie.split(';').forEach(cookie => {
		  const [name] = cookie.split('=');
		  document.cookie = name.trim() + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
		});

		debugLog("pgw clearCookies p3, document.cookie = ", document.cookie);

		await persistor.purge();
		await clearAudioStorage();
		localStorage.clear();
	

		window.location.reload();
	}
	catch(e) {
		debugLog("pgw clearCookies p3, e = ", e)
	}

  };


	  const dumpLsVals = () => {

		/*
		__persist:migratedToIdb__
		__persist:migratedToLocalStorage__
		__persist:prefer_ls
		iosPwaPrompt
		show_session_tour_guide
		*/

		let lsRes
// 
// 		lsRes = localStorage.getItem('iosPwaPrompt')
// 		debugLog("localStorage.getItem iosPwaPrompt = ", lsRes);

		lsRes = localStorage.getItem('__persist:migratedToIdb__')
		debugLog("localStorage.getItem __persist:migratedToIdb__ = ", lsRes);


		lsRes = localStorage.getItem('__persist:migratedToLocalStorage__')
		debugLog("localStorage.getItem __persist:migratedToLocalStorage__ = ", lsRes);

		lsRes = localStorage.getItem('__persist:prefer_ls')
		debugLog("localStorage.getItem __persist:prefer_ls = ", lsRes);



	  };





  useEffect(async () => {
    const usage = await navigator.storage.estimate();
    setStorageConsumption(usage);
  }, []);

  // pgw 27-mar-2026 - play all songs in songlist
  useEffect(() => {
	window.__DEBUG_AUTOPLAY_10S__ = debugAutoplay10s;
  }, [debugAutoplay10s]);


  const resetTourGuide = () => {

	if (true) {
		if (localStorage) localStorage.removeItem("show_session_tour_guide");
	}


  };


  const flipStorage = async () => {

	// pgw 26-sep-2025 - if offline, warn user that the function will stop app working and give them option to abort

	// pgw 02-oct-2025
	const ok = await isReallyOnline(2500);
	if (ok) {
		debugLog('user is online')
	}
	else {
		debugLog('user is offline !!')

		let res = confirm("You are offline.\nDoing this will cause the app to stop working !\n Are you sure you want to continue ?\n(OK to continue; Cancel to do nothing) ?")
		debugLog('res = ', res);
		if (res) {
			debugLog("You pressed OK!");
		} else {
			debugLog("You pressed Cancel - returning...");
			return;
		}
	}


	// pgw 25-sep-2025 - move to new button in debug section
	if (true) {

		debugLog("dumpLsVals 1");
		dumpLsVals()


		  const choice = prompt(
			"Pick an option:\n" +
			"1 = flipStorageBackend localStorage keepOldCopy = false\n" +
			"2 = flipStorageBackend localStorage keepOldCopy = true\n" +
			"3 = flipStorageBackend indexedDB keepOldCopy = false\n" +
			"4 = flipStorageBackend indexedDB keepOldCopy = true"
		  );

			// in Settings (where you prompt for a choice)
			switch (choice) {
			  case "1":
				flipStorageBackend('localStorage', { keepOldCopy: false });
				break;
			  case "2":
				flipStorageBackend('localStorage', { keepOldCopy: true });
				break;
			  case "3":
				flipStorageBackend('indexedDB', { keepOldCopy: false });
				break;
			  case "4":
				flipStorageBackend('indexedDB', { keepOldCopy: true });
				break;
			  default:
				alert("Invalid choice or dialog closed.");
				break;
			}


		debugLog("dumpLsVals 2");
		dumpLsVals()

	}


  };


  return (
    <div className=" space-y-1 dark:text-white px-3 py-3 overflow-y-auto">
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">Current User</span>
            </td>
            <td align="right">
              {currentUser?.displayName}
            </td>
          </tr>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">Active subscription</span>
            </td>
            <td align="right">
              {currentUser?.subscribed ? "Yes": "No"}
            </td>
          </tr>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">Refresh app</span>
            </td>
            <td align="right">
              {" "}
              <Button size="sm" onClick={refreshApp} type="primary">
                Refresh app
              </Button>
            </td>
          </tr>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">Reset Tour guide</span>
            </td>
            <td align="right">
              {" "}
              <Button size="sm" onClick={resetTourGuide} type="primary">
                Reset tour guide
              </Button>
            </td>
          </tr>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">Base player version</span>
            </td>
            <td align="right">v{PackageJSON.version}</td>
          </tr>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">UI components version</span>
            </td>
            <td align="right">v{ComponentPackageJson.version}</td>
          </tr>
          <tr>
            <td>
              <span className="text-sm font-medium text-secondary-900 dark:text-white">App version</span>
            </td>
            <td align="right">{parentVersion ? `v${parentVersion}` : "Running as player-application"}</td>
          </tr>
        </tbody>
      </table>

      <Switch.Group as="div" className={`flex items-center justify-between`} onClick={handleToggleDeveloperTools}>
        <span className="flex-grow flex flex-col">
          <Switch.Label as="span" className="text-sm font-medium text-secondary-900 dark:text-white mr-2" passive>
            Show developer tools
          </Switch.Label>
        </span>

        <Switch checked={showDeveloperTools} onChange={handleToggleDeveloperTools} className={`${showDeveloperTools ? "bg-primary" : "bg-gray-200"} relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200`}>
          <span className="sr-only">Download setlist</span>
          <span className={`${showDeveloperTools ? "translate-x-5" : "translate-x-0"} pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200`}>
            <span className={`${showDeveloperTools ? "opacity-0 ease-out duration-100" : "opacity-100 ease-in duration-200"} absolute inset-0 h-full w-full flex items-center justify-center transition-opacity`} aria-hidden="true">
              <svg className="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 12 12">
                <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <span className={`${showDeveloperTools ? "opacity-100 ease-in duration-200" : "opacity-0 ease-out duration-100"} absolute inset-0 h-full w-full flex items-center justify-center transition-opacity`} aria-hidden="true">
              <svg className="h-3 w-3 text-primary" fill="currentColor" viewBox="0 0 12 12">
                <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
              </svg>
            </span>
          </span>
        </Switch>
      </Switch.Group>
      {showDeveloperTools && (
        <table style={{ width: "100%" }}>
          <tbody>

            <tr>
              <td>
                <span className="text-sm font-medium text-secondary-900 dark:text-white">Deep Refresh</span>
              </td>
              <td align="right">
                <Button size="sm" onClick={deepAppRefresh} type="primary">
                  Deep Refresh
                </Button>
              </td>
            </tr>


            <tr>
              <td>
                <span className="text-sm font-medium text-secondary-900 dark:text-white">Special Options</span>
              </td>
              <td align="right">
                <Button size="sm" onClick={specialOptions} type="primary">
                  Special Options
                </Button>
              </td>
            </tr>



            <tr>
              <td>
                <span className="text-sm font-medium text-secondary-900 dark:text-white">Application debug</span>
              </td>
              <td align="right">
                <Button size="sm" onClick={handleDownloadState} type="primary">
                  Download debug
                </Button>
              </td>
            </tr>

            <tr>
              <td>
                <span className="text-sm font-medium text-secondary-900 dark:text-white">Clear cookies</span>
              </td>
              <td align="right">
                <Button size="sm" onClick={clearCookies} type="primary">
                  Clear cookies
                </Button>
              </td>
            </tr>


            <tr>
              <td>
                <span className="text-sm font-medium text-secondary-900 dark:text-white">Flip Storage Backend</span>
              </td>
              <td align="right">
                <Button size="sm" onClick={flipStorage} type="primary">
                  Flip Storage Backend
                </Button>
              </td>
            </tr>



            <tr>
              <td>
                <span className="text-sm font-medium text-secondary-900 dark:text-white">Debug Play Songlist</span>
              </td>
              <td align="right">
				<div style={{ marginTop: 10 }}>
				  <label>
					<input
					  type="checkbox"
					  checked={debugAutoplay10s}
					  onChange={(e) => setDebugAutoplay10s(e.target.checked)}
					/>
					DEBUG: Autoplay next song after 10s
				  </label>
				</div>
              </td>
            </tr>







            {/* {storageConsumption && (
              <tr>
                <td>
                  <span className="text-sm font-medium text-secondary-900 dark:text-white">Cache used</span>
                </td>
                <td align="right">
                  {(storageConsumption.usage / 1000000).toFixed(0)}/{(storageConsumption.quota / 1000000).toFixed(0)}MB
                </td>
              </tr>
            )} */}

            {sessionError && (
              <tr>
                <td>
                  <span className="text-sm font-medium text-secondary-900 dark:text-white">Session error</span>
                </td>
                <td align="right">{store.getState().session?.error}</td>
              </tr>
            )}

          </tbody>
        </table>
      )}
      <p>
        <br />
        <br />
        <br />
      </p>
    </div>
  );
};

export default Settings;
